module.exports = __webpack_public_path__ + "img/takahashi.cabd6ce4.jpg";